export function getStaticUrl(path: string) {
  return (window.staticAssetsUrl?.replace(/\/$/, '') || '')+'/'+path.replace(/^\//, '')
}
